import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IFormConfig } from '../../../../types/form-builder';
import FormBuilder from '../../../common/form-builder/FormBuilder';

export default function ShipHandledForm(props: { shipTypes: any }) {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { shipTypes } = props;

  const formConfig: IFormConfig[] = [
    {
      class:
        'col-md-12 col-sm-12 col-lg-12 col-xs-12 col-xs-12 m-l-custom-sixteen-space-col',
      fieldWrapperClass: 'm-c-form-group mb-btm-space',
      name: 'shipType',
      label: 'Ship Type',
      control: control,
      fieldType: 'select',
      dataSource: shipTypes,
      displayExpr: 'optionValueText',
      valueExpr: 'optionValueCode',
      isRequired: true,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-md-12 col-sm-12 col-lg-12 col-xs-12 col-xs-12 m-l-custom-sixteen-space-col',
      fieldWrapperClass: 'm-c-form-group mb-btm-space',
      name: 'shipSize',
      label: 'Ship Size',
      control: control,
      fieldType: 'text',
      maxLength: 100,
    },
  ];

  return (
    <div className="row m-l-custom-sixteen-space-row">
      <FormBuilder formConfig={formConfig} />
    </div>
  );
}
